import React from "react";
import { BlogLayout } from "@/components/layout/BlogLayout";
import { TableOfContents } from "@/components/blog/TableOfContents";
import { PostHeader } from "@/components/blog/PostHeader";
import { PostIntroSection } from "@/components/blog/PostIntroSection";
import { tendenciasSeo2026TableOfContents } from "./tendencias-seo-2026/tableOfContents";
import { ArticleContent } from "./tendencias-seo-2026/ArticleContent";
import { RelatedArticles } from "@/components/blog/RelatedArticles";
import { Breadcrumbs } from "@/components/shared/Breadcrumbs";
import { UpdateDate } from "@/components/shared/UpdateDate";
import tendenciasSeoImage from "@/assets/blog-tendencias-seo-2026.jpg";

export function TendenciasSeo2026Post() {
  return (
    <>
      <PostHeader 
        title="Tendencias SEO 2026: Guía para dominar el nuevo ecosistema de búsqueda con IA | SEOEVOLUTION"
        description="Las 7 tendencias SEO clave en 2026: búsqueda conversacional, E-E-A-T, contenido para IA, SEO local y checklist de acción. Guía completa para adaptar tu estrategia."
        keywords="tendencias SEO 2026, SEO con IA, GEO optimización, E-E-A-T, búsqueda conversacional, SEO local, Core Web Vitals"
        author="Ángel Ruz"
        canonicalUrl="https://agenciaseoevolution.com/blog/tendencias-seo-2026"
      />

      <BlogLayout>
        <article className="py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-seo-darkBlue to-seo-dark opacity-90"></div>
          <div className="container mx-auto px-4 md:px-6 relative z-10">
            <div className="max-w-5xl mx-auto">
              <Breadcrumbs />
              
              <PostIntroSection 
                category="SEO Y ESTRATEGIA DIGITAL"
                title="Tendencias SEO 2026: Guía completa para dominar el nuevo ecosistema de búsqueda con IA"
                date="11 Abril, 2026"
                author="Ángel Ruz"
                imageUrl={tendenciasSeoImage}
                imageAlt="Tendencias SEO 2026: el futuro del posicionamiento web con IA"
                description="El SEO no es lo que era. Con la irrupción masiva de la inteligencia artificial en la búsqueda, 2026 es el año decisivo donde las reglas cambian — no solo para quienes quieren tráfico, sino para cualquiera que apueste por visibilidad sostenible. Desde la búsqueda conversacional hasta la optimización para motores generativos (GEO), pasando por E-E-A-T, contenido multimodal y SEO local: estas son las tendencias clave y cómo adaptar tu estrategia desde hoy."
              />

              <UpdateDate 
                date="Abril 2026"
                updatesSection={
                  <div>
                    <p className="font-semibold mb-2">Novedades abril 2026:</p>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      <li>GEO (Generative Engine Optimization) se consolida como disciplina</li>
                      <li>E-E-A-T se convierte en factor decisivo para citación por IA</li>
                      <li>Búsqueda por voz y multimodal en plena explosión</li>
                      <li>Contenido genérico pierde relevancia frente a contenido diferenciado</li>
                    </ul>
                  </div>
                }
              />

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-seo-dark/50 rounded-xl p-6 shadow-lg backdrop-blur-xs">
                  <ArticleContent />
                  <RelatedArticles currentSlug="/tendencias-seo-2026" category="SEO Inteligente" />
                </div>
                
                <div className="lg:col-span-1">
                  <TableOfContents items={tendenciasSeo2026TableOfContents} />
                </div>
              </div>
            </div>
          </div>
        </article>
      </BlogLayout>
    </>
  );
}
